<template lang="pug">
  #about
    Modal
    Header
    History
    Team
    Contact#contact
    Finisher
    Footer
</template>

<script>
import Modal from '@/components/Shared/Modal.vue'
import Contact from '@/components/About/Contact.vue'
import Finisher from '@/components/Shared/Finisher.vue'
import Footer from '@/components/Shared/Footer.vue'
import Header from '@/components/About/Header.vue'
import History from '@/components/About/History.vue'
import Team from '@/components/About/Team.vue'
import VueScrollTo from 'vue-scrollto'

export default {
  name: 'Home',
  components: {
    Modal,
    Contact,
    Finisher,
    Footer,
    Header,
    History,
    Team
  },
  mounted () {
    if(this.$route.query.section) {
      this.scrollToSection('#' + this.$route.query.section)
    } else {
      VueScrollTo.scrollTo({y: 0})
    }
  },
  watch: {
    currentSection () {
      this.scrollToSection('#' + this.currentSection)
    }
  },
  methods: {
    scrollToSection (section) {
      VueScrollTo.scrollTo(section, 500, {...this.scrollOptions, offset: -100})
    }
  },
  computed: {
    currentSection () {
      return this.$route.query.section || undefined
    }
  },
  data(){
    return{
      duo:[
        { name: 'Home', link: '/home' },
      ],
      trio:[
        {
          title: 'Target Identification',
          text: 'Identify comprehensive lists of targets matching detailed criteria. Keep track of the latest news and developments.',
          image: '@/assets/imagesnew/Icon Target.svg'
        }
      ]
    }

  }
}
</script>

<style scoped lang="scss">


</style>
